"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedBlockMoreActionsMenu = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_1 = require("mobx");
var react_1 = __importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var Configuration_1 = require("@CommonFrontend/Styles/Configuration/Configuration");
var SavedBlockMoreActionsMenu = (function (_super) {
    __extends(SavedBlockMoreActionsMenu, _super);
    function SavedBlockMoreActionsMenu() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.isOptionMenuOpened = false;
        _this.onOptionMenuClick = function (event) {
            event.stopPropagation();
            _this.isOptionMenuOpened = !_this.isOptionMenuOpened;
        };
        _this.onCloseOptionMenu = function () {
            _this.isOptionMenuOpened = false;
        };
        _this.handleToggleLockEditing = function () {
            _this.props.onToggleEditingIsLockedToAdmins();
        };
        _this.handleDeleteClick = function (event) {
            event.stopPropagation();
            _this.props.onDeleteClick();
        };
        return _this;
    }
    SavedBlockMoreActionsMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, userIsAdmin = _a.userIsAdmin, editingIsLockedToAdmins = _a.editingIsLockedToAdmins, className = _a.className, blockId = _a.blockId, hideCopyBlockIdOption = _a.hideCopyBlockIdOption;
        var userCanEdit = !editingIsLockedToAdmins || userIsAdmin;
        return (react_1.default.createElement("div", { className: "saved-block-more-actions" },
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.contentSidebarZIndex }, function (_a) {
                var zIndex = _a.zIndex;
                return (react_1.default.createElement(kaleidoscope_1.OptionMenu, { style: { zIndex: zIndex }, size: "large", className: (0, classnames_1.default)("saved-block-more-actions-menu__overflow-actions", className), onClose: _this.onCloseOptionMenu, button: react_1.default.createElement(kaleidoscope_1.IconButton, { onClick: _this.onOptionMenuClick, icon: react_1.default.createElement(icons_1.OptionsVertical, null), tooltip: {
                            content: "More Actions",
                            position: kaleidoscope_1.TooltipPosition.Top,
                            show: _this.isOptionMenuOpened ? false : undefined,
                        } }) },
                    react_1.default.createElement(kaleidoscope_1.Stack, { padding: "xs", paddingTop: "xxs", paddingBottom: "xxs" },
                        react_1.default.createElement(kaleidoscope_1.Toggle, { disabled: !userIsAdmin, label: "Lock editing to admins", value: editingIsLockedToAdmins, onChange: _this.handleToggleLockEditing })),
                    !hideCopyBlockIdOption && (react_1.default.createElement(kaleidoscope_1.CopyToClipboard, { value: blockId }, function (_a) {
                        var onCopy = _a.onCopy;
                        return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { closeOnClick: false, onClick: function (event) {
                                event.stopPropagation();
                                onCopy();
                            } }, "Copy block ID"));
                    })),
                    react_1.default.createElement(kaleidoscope_1.OptionMenuSeparator, null),
                    react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { destructive: true, onClick: _this.handleDeleteClick, disabled: !userCanEdit }, "Delete block")));
            })));
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], SavedBlockMoreActionsMenu.prototype, "isOptionMenuOpened", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockMoreActionsMenu.prototype, "onOptionMenuClick", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockMoreActionsMenu.prototype, "onCloseOptionMenu", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockMoreActionsMenu.prototype, "handleToggleLockEditing", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], SavedBlockMoreActionsMenu.prototype, "handleDeleteClick", void 0);
    SavedBlockMoreActionsMenu = __decorate([
        mobx_react_1.observer
    ], SavedBlockMoreActionsMenu);
    return SavedBlockMoreActionsMenu;
}(react_1.default.Component));
exports.SavedBlockMoreActionsMenu = SavedBlockMoreActionsMenu;
